import React, { useState, useEffect } from 'react';
import { EvidenciaImg } from '../../../types/ot.types';
import { OtService } from '../services/OtService';
import { FileUploaderPreview } from '../../../components/FileUploaderPreview';

export const ControlAdministrativoOT: React.FC<{ ordenId: string }> = ({ ordenId }) => {
    const [isPagado, setIsPagado] = useState(false);
    const [isFacturado, setIsFacturado] = useState(false);
    const [folioFactura, setFolioFactura] = useState('');
    const [archivosPago, setArchivosPago] = useState<EvidenciaImg[]>([]);
    const [archivosFactura, setArchivosFactura] = useState<EvidenciaImg[]>([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [alert, setAlert] = useState<{ type: string, message: string } | null>(null);

    // Cargar estado actual de la OT
    useEffect(() => {
        OtService.getExpediente(ordenId).then(res => {
            if (res?.data) {
                setIsPagado(res.data.orden.is_pagado == 1);
                setIsFacturado(res.data.orden.is_facturado == 1);
                setFolioFactura(res.data.orden.folio_factura_coven || '');
                setArchivosPago(res.data.archivos.filter((a: any) => a.referencia_contexto === "PAGO_ADMIN" && a.contexto == "STEP_VERIFICACION_PAGO"));
                setArchivosFactura(res.data.archivos.filter((a: any) => a.referencia_contexto === "FACTURA_ADMIN" && a.contexto == "STEP_VERIFICACION_PAGO"));
            }
            setIsLoading(false);
        });
    }, [ordenId]);

    const handleSave = async () => {
        setIsSaving(true);
        setAlert(null);
        try {
            await OtService.saveEstatusAdministrativo(ordenId, isPagado, isFacturado, folioFactura, archivosPago, archivosFactura);
            setAlert({ type: 'success', message: 'Los estatus administrativos se guardaron correctamente.' });
            setTimeout(() => setAlert(null), 3000);
        } catch (error: any) {
            setAlert({ type: 'danger', message: error.message || 'Error al guardar la información.' });
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><div className="spinner-border text-primary"></div></div>;

    return (
        <div className="card shadow-sm border-primary border-top border-4 mb-4 animate__animated animate__fadeIn">
            <div className="card-header pb-0 border-bottom-0">
                <h5 className="fw-bold text-primary"><i className="fas fa-briefcase me-2"></i> Panel de Control Administrativo</h5>
            </div>
            <div className="card-body">
                {alert && <div className={`alert alert-${alert.type}`}>{alert.message}</div>}

                <div className="row g-4">
                    <div className="col-md-6 border-end pe-md-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="fw-bold mb-0 text-secondary">Control de Pagos</h6>
                            <div className="form-check form-switch fs-5 mb-0">
                                <input className="form-check-input cursor-pointer" type="checkbox" role="switch" checked={isPagado} onChange={(e) => setIsPagado(e.target.checked)} />
                                <label className={`form-check-label fw-bold small ms-2 ${isPagado ? 'text-success' : 'text-muted'}`}>
                                    {isPagado ? "ORDEN PAGADA" : "Pendiente de Pago"}
                                </label>
                            </div>
                        </div>
                        <FileUploaderPreview label="Comprobantes de Pago (SPEI/Transferencia)" archivos={archivosPago} setArchivos={setArchivosPago} multiple={true} accept="image/*,application/pdf" />
                    </div>

                    <div className="col-md-6 ps-md-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="fw-bold mb-0 text-secondary">Control de Facturación</h6>
                            <div className="form-check form-switch fs-5 mb-0">
                                <input className="form-check-input cursor-pointer" type="checkbox" role="switch" checked={isFacturado} onChange={(e) => setIsFacturado(e.target.checked)} />
                                <label className={`form-check-label fw-bold small ms-2 ${isFacturado ? 'text-success' : 'text-muted'}`}>
                                    {isFacturado ? "ORDEN FACTURADA" : "Pendiente Facturar"}
                                </label>
                            </div>
                        </div>

                        <div className="form-group mb-3">
                            <label className="small fw-bold text-muted">Folio de Factura (Opcional)</label>
                            <input type="text" className="form-control form-control-sm" value={folioFactura} onChange={(e) => setFolioFactura(e.target.value)} placeholder="Ej. FAC-90123" disabled={!isFacturado} />
                        </div>

                        <FileUploaderPreview label="Archivos de Factura (PDF / XML)" archivos={archivosFactura} setArchivos={setArchivosFactura} multiple={true} accept=".pdf,.xml" disabled={!isFacturado} />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                    <button className="btn btn-primary fw-bold shadow-sm px-4" onClick={handleSave} disabled={isSaving}>
                        {isSaving ? <><i className="fas fa-spinner fa-spin me-2"></i> Guardando...</> : <><i className="fas fa-save me-2"></i> Guardar Cambios Administrativos</>}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default ControlAdministrativoOT;